
import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const response = await fetch('https://readdy.ai/api/form/submit/contact-form-detailed', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          projectType: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: ['+91 98765 43210', '+91 87654 32109'],
      color: '#7E887E'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: ['info@lavinenterprises.com', 'sales@lavinenterprises.com'],
      color: '#7E887E'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Head Office',
      details: ['123 Business District', 'New Delhi - 110001', 'India'],
      color: '#7E887E'
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      details: ['Monday - Friday: 9:00 AM - 6:00 PM', 'Saturday: 9:00 AM - 2:00 PM'],
      color: '#7E887E'
    }
  ];

  const offices = [
    {
      city: 'Delhi NCR',
      address: '123 Business District, New Delhi - 110001',
      phone: '+91 98765 43210',
      email: 'delhi@lavinenterprises.com'
    },
    {
      city: 'Mumbai',
      address: '456 Industrial Area, Mumbai - 400001',
      phone: '+91 98765 43211',
      email: 'mumbai@lavinenterprises.com'
    },
    {
      city: 'Bangalore',
      address: '789 Tech Park, Bangalore - 560001',
      phone: '+91 98765 43212',
      email: 'bangalore@lavinenterprises.com'
    },
    {
      city: 'Pune',
      address: '321 Commercial Hub, Pune - 411001',
      phone: '+91 98765 43213',
      email: 'pune@lavinenterprises.com'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#7E887E' }}>
              Contact Us
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Get in touch with our experts for technical support, product information, or project consultation
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            
            <div className="grid lg:grid-cols-2 gap-12">
              
              {/* Contact Form */}
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold mb-6" style={{ color: '#7E887E' }}>Send Us a Message</h2>
                
                <form id="contact-form-detailed" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors"
                        style={{ focusRingColor: '#7E887E' }}
                        onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                        placeholder="Your full name"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors"
                        style={{ focusRingColor: '#7E887E' }}
                        onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                        placeholder="your.email@company.com"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors"
                        style={{ focusRingColor: '#7E887E' }}
                        onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                        placeholder="+91 98765 43210"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 transition-colors"
                        style={{ focusRingColor: '#7E887E' }}
                        onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                        placeholder="Your company name"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 mb-2">
                      Project Type
                    </label>
                    <div className="relative">
                      <select
                        id="projectType"
                        name="projectType"
                        value={formData.projectType}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg text-sm appearance-none bg-white focus:outline-none focus:ring-2 transition-colors"
                        style={{ focusRingColor: '#7E887E' }}
                        onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                        onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                      >
                        <option value="">Select project type</option>
                        <option value="infrastructure">Infrastructure & Government</option>
                        <option value="residential">Residential & Commercial</option>
                        <option value="industrial">Industrial Plants</option>
                        <option value="public-works">Public Works</option>
                        <option value="rmc">RMC Plants</option>
                        <option value="specialty">Specialty Applications</option>
                        <option value="other">Other</option>
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="ri-arrow-down-s-line text-gray-400"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm resize-vertical focus:outline-none focus:ring-2 transition-colors"
                      style={{ focusRingColor: '#7E887E' }}
                      onFocus={(e) => e.target.style.borderColor = '#7E887E'}
                      onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
                      placeholder="Tell us about your project requirements, technical questions, or how we can help you..."
                    ></textarea>
                    <div className="text-right text-sm text-gray-500 mt-1">
                      {formData.message.length}/500 characters
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full text-white py-3 px-6 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                    style={{ backgroundColor: '#7E887E' }}
                    onMouseEnter={(e) => !isSubmitting && (e.target.style.backgroundColor = '#6B756B')}
                    onMouseLeave={(e) => !isSubmitting && (e.target.style.backgroundColor = '#7E887E')}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                      <p className="text-green-800">Thank you! Your message has been sent successfully. We'll get back to you soon.</p>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                      <p className="text-red-800">Sorry, there was an error sending your message. Please try again or contact us directly.</p>
                    </div>
                  )}
                </form>
              </div>

              {/* Contact Information */}
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#7E887E' }}>Get In Touch</h2>
                  <p className="text-gray-600 leading-relaxed mb-8">
                    Ready to discuss your construction chemical needs? Our technical experts are here to help you find the right solutions for your project.
                  </p>
                </div>

                <div className="grid gap-6">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
                      <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                        <i className={`${info.icon} text-2xl`} style={{ color: info.color }}></i>
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-800 mb-1">{info.title}</h3>
                        {info.details.map((detail, detailIndex) => (
                          <p key={detailIndex} className="text-gray-600 text-sm">{detail}</p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Quick Contact */}
                <div className="text-white p-6 rounded-lg" style={{ backgroundColor: '#7E887E' }}>
                  <h3 className="text-xl font-semibold mb-4">Need Immediate Assistance?</h3>
                  <p className="mb-4 opacity-90">For urgent technical support or project emergencies, call our 24/7 helpline:</p>
                  <div className="flex items-center space-x-3">
                    <i className="ri-phone-line text-2xl"></i>
                    <span className="text-xl font-semibold">+91 98765 43210</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Regional Offices */}
            <div className="mt-20">
              <h2 className="text-3xl font-bold mb-12 text-center" style={{ color: '#7E887E' }}>Our Regional Offices</h2>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {offices.map((office, index) => (
                  <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#7E887E' }}>{office.city}</h3>
                    <div className="space-y-3">
                      <div className="flex items-start space-x-3">
                        <i className="ri-map-pin-line text-gray-400 mt-1"></i>
                        <p className="text-gray-600 text-sm">{office.address}</p>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-phone-line text-gray-400"></i>
                        <p className="text-gray-600 text-sm">{office.phone}</p>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-mail-line text-gray-400"></i>
                        <p className="text-gray-600 text-sm">{office.email}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Map */}
            <div className="mt-16">
              <h2 className="text-3xl font-bold mb-8 text-center" style={{ color: '#7E887E' }}>Find Us</h2>
              <div className="bg-gray-100 rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.2416097754716!2d77.20902731508047!3d28.627981982421896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd0683f3e6d5%3A0x8c2c2c2c2c2c2c2c!2sConnaught%20Place%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1635000000000!5m2!1sen!2sin"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Lavin Enterprises Location"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
